// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';

import FullButton from './FullButtons/FullButton';

export default class ValidationButton extends PureComponent<Props> {
  render() {
    const styles = getStyles();
    const { disabled, isLoading, noMargin, onPress, text, testID } = this.props;

    let containerStyle = {};
    if (!noMargin) {
      containerStyle = styles.buttonContainer;
    }

    return (
      <View style={containerStyle}>
        <FullButton
          testID={testID}
          text={text}
          disabled={disabled}
          onPress={onPress}
          isLoading={isLoading}
          style={disabled && styles.disabledButton}
        />
      </View>
    );
  }
}

type Props = {
  disabled?: boolean,
  isLoading?: boolean,
  noMargin?: boolean,
  onPress: Function,
  text: string,
  testID?: string,
};

const getStyles = () =>
  StyleSheet.create({
    buttonContainer: {
      margin: 20,
    },
    disabledButton: {
      backgroundColor: '#373737',
      opacity: 0.8,
    },
  });
